import useSeo from "@/lib/useSeo";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PrintersHero from "@/components/printers/PrintersHero";
import PrintersMirror from "@/components/printers/PrintersMirror";
import PrintersSolution from "@/components/printers/PrintersSolution";
import PrinterTable from "@/components/printers/PrinterTable";
import PrintersUseCases from "@/components/printers/PrintersUseCases";
import PrintersWhy from "@/components/printers/PrintersWhy";
import PrintersHowItWorks from "@/components/printers/PrintersHowItWorks";
import PrintersCTA from "@/components/printers/PrintersCTA";

export default function PrintersPage() {
  useSeo({
    title: "Printers — ED Tech Depot | Canon Wide-Format Printers for K-12 Schools",
    description:
      "Choose the right Canon wide-format printer for your school — 24\", 36\", and 44\" indoor/outdoor options for posters, banners, and signage. Built specifically for K-12.",
    path: "/printers",
  });

  return (
    <div data-testid="printers-page" className="min-h-screen bg-[#F4F6F4]">
      <Header />
      <main>
        <PrintersHero />
        <PrintersMirror />
        <PrintersSolution />
        <PrinterTable />
        <PrintersUseCases />
        <PrintersWhy />
        <PrintersHowItWorks />
        <PrintersCTA />
      </main>
      <Footer />
    </div>
  );
}
